import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { AzureApiService } from "../../services/azure-api.service";
import {DtoCustomerReportFilter} from "./models/DtoCustomerReportFilter";
import {DtoCustomerReport} from "./models/DtoCustomerReport";
import {DtoCustomerOverviewBaseItems} from "./models/DtoCustomerOverviewBaseItems";
import {DtoCustomersToCmExport} from "./models/DtoCustomersToCmExport";
import {DtoCustomerFilter} from "./models/DtoCustomerFilter";

@Injectable()
export class MailingService {
    private apiUrl: string;

    constructor(private http: AzureApiService) {
        this.apiUrl = 'customer'
    }

    public getCustomerReport = (filter: DtoCustomerReportFilter): Observable<DtoCustomerReport[]> => {
        return this.http.post<DtoCustomerReport[]>(`${this.apiUrl}/report/`, filter);
    };

    public getCustomerReportBaseItems = (): Observable<DtoCustomerOverviewBaseItems> => {
        return this.http.get<DtoCustomerOverviewBaseItems>(`${this.apiUrl}/report/baseitems`);
    };

    public exportCustomersToCM = (customers: DtoCustomerReport[]): Observable<DtoCustomersToCmExport> => {
        return this.http.post<DtoCustomersToCmExport>(`${this.apiUrl}/exporttocm/`, customers);
    };

    public searchCustomerForReport = (customers: DtoCustomerFilter): Observable<DtoCustomerReport[]> => {
        return this.http.post<DtoCustomerReport[]>(`${this.apiUrl}/report/searchcustomer/`, customers);
    };
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/app/marketing/mailing/mailing.service.ts